import React from "react";
import { Link } from "react-router-dom";
import HomeNav from "../components/Nav";
import Cards from "../components/Cards";
import homeImg from "../assets/img/homeImg.svg";
import { FaArrowRight } from "react-icons/fa";


function Home() {
  return (
    <div>
      <HomeNav />
      <div className="container d-flex flex-column min-vh-100 justify-content-center align-items-center">
        <img src={homeImg} style={{ width: "250px", height: "auto" }}/>
        <div className="mt-4">
          <h1 className="title arabic-text">حياك الله</h1>
          <h1 className="title english-text">Hello</h1>
        </div>

        <div className="mt-4 ">
          <p className="text-center arabic-text">صمم بطاقة التهنئة الخاصة بك</p>
          <p className="text-center english-text">Design your own greeting card</p>
        </div>
        <div className="mt-4 ">
          <Link to="/cards">
            <button className="btn btn-primary"><FaArrowRight size={17} /></button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Home;
